import React, {
  useState,
  useContext,
  useCallback,
  useEffect,
  ReactNode
} from "react";

interface IGeolocationContext {
  coordinates: GeolocationCoordinates;
  getCoordinates: () => void;
}

const GeolocationContext = React.createContext<IGeolocationContext>({
  coordinates: null,
  getCoordinates: () => {}
});

GeolocationContext.displayName = "Geolocation";

export function GeolocationProvider(props: { children?: ReactNode }) {
  const [coordinates, setCoordinates] = useState<GeolocationCoordinates>();
  const getCoordinates = useCallback(() => {
    navigator.geolocation.getCurrentPosition(
      position => {
        setCoordinates(position.coords);
      },
      _error => {},
      { timeout: Infinity, enableHighAccuracy: true, maximumAge: 0 }
    );
  }, []);

  return (
    <GeolocationContext.Provider value={{ coordinates, getCoordinates }}>
      {props.children}
    </GeolocationContext.Provider>
  );
}

export function useCoordinates() {
  const { coordinates, getCoordinates } = useContext(GeolocationContext);

  useEffect(() => {
    getCoordinates();
  }, []);

  return coordinates;
}
